"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDataType extends new_item_1.default {
    constructor(newDataType) {
        super();
        this.name = newDataType.name;
        this.dataType = newDataType.dataType;
        this.organisationId = newDataType.organisationId;
        this.unitId = newDataType.unitId;
        this.unitDetails = newDataType.unitDetails;
        this.applyRate = newDataType.applyRate;
        this.rateUnitId = newDataType.rateUnitId;
        this.rateUnitDetails = newDataType.rateUnitDetails;
        this.categoryId = newDataType.categoryId;
        this.categoryDetails = newDataType.categoryDetails;
        this.global = newDataType.global;
        this.defaultRateMultiple = newDataType.defaultRateMultiple;
        this.defaultMultiple = newDataType.defaultMultiple;
        this._permission = newDataType._permission;
    }
}
exports.default = NewDataType;
//# sourceMappingURL=new-dataType.js.map